import React, { useCallback, useEffect, useRef, useState } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Col, Container, Input, Row, Table } from "reactstrap";
import CustomerDetails from "./CustomerDetails";
import { useFormik } from "formik";
import {
    ApplyBidsValidationSchema,
    ShippingQuotationValidationSchema
} from "../schema/SmartQuotationsSchema";
import {
    QUOTATION_RESULT_SELECTED,
    SMART_QUOTATION_VALUE_UPDATE, UPDATE_SEARCH_INSTANT_RATE_DATA
} from "../../../../store/InstantRate/actionType";
import AddressDetails from "./AddressDetails";
import { useDispatch, useSelector } from "react-redux";
import { GET_COMMODITY_DATA, GET_UOM_DATA } from "../../../../store/Global/actiontype";
import { getAllIncoTerms, getInstantRateLocation } from "../../../../store/InstantRate/actions";
import { getVendorCarrierDataAction } from "../../../../store/Parties/Vendor/action";
import { getCompanyCityData } from "../../../../store/Settings/actions";
import {
    ADD_QUOTE_MODAL_CHARGES,
    QUOTE_MODAL_INITIAL,
    REMOVE_QUOTE_MODAL_CHARGES,
    UPDATE_QUOTE_MODAL_CHARGES
} from "../../../../store/Sales/Quotation/actiontype";
import { filter_icon } from "../../../../assets/images";
import Select from "react-select";
import {
    calculateTotalsFromTariffs,
    formatCurrency,
    getCurrencySymbol,
    getMarketPlaceRate,
    isAnyValueEmpty,
    isAnyValueEmptyInArray,
    isObjectEmpty,
    mergeTariffDetails,
    totalAmtArry,
    mergeTotalsByCurrency,
    formatServerDate,
    hasErrorKeys,
    convertCurrency
} from "../../../../components/Common/CommonLogic";
import Charges from "./Charges";
import { showErrorToast, showWarnToast } from "../../../../components/Common/CustomToast";
import ShipmentDetails from "./ShipmentDetails";
import { applyBiddingChargesValidate, errorGroupByHeader, mainChargesValidate, smartQuotationMainChargesValidate } from "../../partials/ValidationForm";
import { useLocation, useNavigate } from "react-router-dom";
import { BID_SUBMITTED, CUST_APPRVD_PENDING, draft, QUOTATION_EDITED, VERIFIED } from "../../../Dashboard/Partials/initialData";
import { getActiveNetworkInquiriesViewDetails, getTenantQuotationSummeryById, postTenantQuotationSummeryDetails } from "../../../../store/Sales/actions";
import Flatpickr from "react-flatpickr";
import PreQuotationsCharges from "./PreQuotationsCharges";
import { getMainChargeObjRemoveEmpty, getOriginalQuoteData, overAllMarginHandler, processOthersCharge, subTotalHandler } from "../../../../Utils/QuotationsChargesUtils";
import ConfirmationModal from "../../../../components/Common/ConfirmationModal";

const ShippingQuotationForm = ({ tabName, quotation, isLoading, setPreviewModal, QuoteModalHandler, toggleRightCanvas, reloadChargesRef }) => {
    const [open, setOpen] = useState(['customerdetails', 'chargesdetails']);
    const dispatch = useDispatch();
    const newdata = [];
    const [totalsByCurrency, setTotalsByCurrency] = useState([]);
    const { activeQuotationsViewDetails } = useSelector((state) => state?.sales);
    const quoteData = useSelector((state) => state.instantRate.quote_selected_data);
    const quoteTenantdata = useSelector((state) => state.instantRate.quote_selected_tenantdata);
    const mainChargeObj = useSelector((state) => state?.quotation?.mainChargeObj);
    const { vendor_carrier_data, vendor_loader } = useSelector((state) => state?.vendor);
    const { status_master, reason_master, oceanPort_data, surchargeCode_data, UOM_data, currency_data, container_data, vendor_data } = useSelector((state) => state?.globalReducer);
    const { smartQuotationsValues } = useSelector((state) => state.instantRate);
    const { currency_ExchangeRate } = useSelector((state) => state.quotation);
    const { tenant_info } = useSelector((state) => state?.settings);
    const [tariffDetails, setTariffDetails] = useState([]);
    const [chargesValidation, setChargesValidation] = useState([]);
    const navigateState = useLocation();
    const [isApplyBids, setIsApplyBids] = useState(false);
    const [isAdditionalBooking, setIsAdditionalBooking] = useState(false);
    const [inquiriesId, setInquiriesId] = useState(0);
    const [inquiriesDetailsData, setInquiriesDetailsData] = useState({});
    const [isBidingBtnClick, setIsBidingBtnClick] = useState(false);
    const navigate = useNavigate();
    const [smartQuotationsFormError, setSmartQuotationsFormError] = useState({});
    const hasRun = useRef(false);
    const [locationFrom, setLocationFrom] = useState('');
    const [quoteTotal, setQuoteTotal] = useState([]);
    const [mainObjTotal, setMainObjTotal] = useState([]);
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [bookingRequestTitle] = useState('Confirm Quotation Update');
    const [bookingRequestMessage] = useState('Once submitted, the updated charges will be sent to the shipper for review and approval. They will receive a notification with the revised quotation details.');
    const [bookingRequestShortMesssage] = useState('The shipper will be notified immediately and will have the option to approve or reject the updated quotation.');
    const [bookingRequestButtonText] = useState('Submit');

    useEffect(() => {
        dispatch({ type: QUOTE_MODAL_INITIAL });
        dispatch({ type: GET_UOM_DATA });
        dispatch({ type: GET_COMMODITY_DATA });
        dispatch(getVendorCarrierDataAction(''));
        if (!isApplyBids) {
            dispatch(getAllIncoTerms());
            dispatch(getInstantRateLocation());
            dispatch(getCompanyCityData());
        }
    }, [dispatch, isApplyBids]);

    const toggle = (id) => {
        if (open.includes(id)) {
            setOpen(open.filter(openId => openId !== id)); // collapse
        } else {
            setOpen([...open, id]); // open
        }
    };

    useEffect(() => {
        //console.log(tenant_info, "tenant_info");
        //console.log(quoteData, "quoteData Shipping Quotation Form");
        if (quoteData.length > 0 && locationFrom === 'bookingLeads' && isAdditionalBooking) {
            const quoteTotal = calculateTotalsFromTariffs(quoteData);
            setQuoteTotal(quoteTotal);
        }
    }, [quoteData, locationFrom, isAdditionalBooking])

    useEffect(() => {
        //console.log(mainChargeObj, "mainChargeObj");
        setChargesValidation([]);
        if (mainChargeObj.length > 0) {
            const newTotals = calculateTotalsFromTariffs(mainChargeObj);
            //console.log(newTotals, "newTotals mainChargeObj");
            //const mergedTotals = mergeTotalsByCurrency(totalsByCurrency, newTotals);
            setMainObjTotal(newTotals);
            //setTotalsByCurrency([mergedTotals]);
            if (isApplyBids || isAdditionalBooking) {
                let validations = [];
                mainChargeObj[0].tariffDetails.map((obj) => {
                    obj.fclTariffBreakDowns.map((object) => {
                        let errorObject = applyBiddingChargesValidate(object, obj?.header);
                        validations.push(errorObject)
                    });
                });
                //console.log(validations, "validations error");
                setChargesValidation(errorGroupByHeader(validations));
            } else {
                let validations = [];
                mainChargeObj[0].tariffDetails.map((obj) => {
                    obj.fclTariffBreakDowns.map((object) => {
                        let errorObject = smartQuotationMainChargesValidate(object, obj?.header);
                        validations.push(errorObject)
                    });
                });
                //console.log(validations, "validations error");
                setChargesValidation(errorGroupByHeader(validations));
            }


            if (!hasRun.current) {
                hasRun.current = true;
                dispatch({
                    type: SMART_QUOTATION_VALUE_UPDATE,
                    payload: { quote_currency: { value: 'US DOLLAR', label: 'USD', currencyCode: 'USD', id: 3, version: 0 } },
                });
            }
        }
    }, [mainChargeObj, quoteTotal]);

    useEffect(() => {
        const currentUrl = window.location.href;
        //console.log(currentUrl, "currentUrl");
        if (currentUrl.includes("/apply/quotation/bids")) {
            setIsApplyBids(true);
        }
        console.log(navigateState?.state, "navigateState?.state");
        if (navigateState?.state?.data !== undefined) {
            //console.log(navigateState?.state, "navigateState?.state");
            setLocationFrom(navigateState?.state?.locationFrom || '');
            setInquiriesDetailsData(navigateState?.state?.data);
            setIsApplyBids(true);
            setInquiriesId(navigateState?.state?.inquiriesId);
            if (navigateState?.state?.inquiriesId !== '' && navigateState?.state?.inquiriesId !== undefined) {
                let url = '?inquiryId=' + navigateState?.state?.inquiriesId;
                //console.log(url, "URL");
                dispatch(getActiveNetworkInquiriesViewDetails(url));
            }
            if (navigateState?.state?.locationFrom === 'bookingLeads') {
                dispatch(getTenantQuotationSummeryById(navigateState?.state?.data?.quotationId));
                setIsApplyBids(false);
                setIsAdditionalBooking(true);
            }

            const headers = [
                "ORIGIN_INLAND_CHARGES",
                "ORIGIN_LOCAL_PORT_CHARGES",
                "FREIGHT_CHARGES",
                "DESTINATION_LOCAL_PORT_CHARGES",
                "DESTINATION_INLAND_CHARGES",
            ];
            const tariffDetails = headers.map(header => ({
                header,
                fclTariffBreakDowns: [],
                selected: true,
            }));

            //console.log(tariffDetails, "tariffDetails SHIP");
            setTariffDetails(tariffDetails);

            setOpen(['shipmentdetails', 'chargesdetails', 'additionaldetails']);
        } else {
            //chargesLoad(tabName);
            //navigate(-1);
        }
    }, [navigateState, tabName]);

    /**
     * Loads the default charges based on shipment type
     * @param {string} shipmentType - Type of shipment (defaults to FCL)
     */
    const chargesLoad = (shipmentType = 'FCL') => {
        try {
            //console.log("chargesLoad in Shipment Quotation");
            // Only set isDefault to true for FCL shipments
            let id = 'quote_0';
            let charge_name = 'FREIGHT_CHARGES';
            dispatch({ type: ADD_QUOTE_MODAL_CHARGES, payload: { id, charge_name, value: true, name: 'isDefault' } });
            // Define charge headers based on shipment type
            const chargeHeaders = {
                'FCL': [
                    "ORIGIN_INLAND_CHARGES",
                    "ORIGIN_LOCAL_PORT_CHARGES",
                    "FREIGHT_CHARGES",
                    "DESTINATION_LOCAL_PORT_CHARGES",
                    "DESTINATION_INLAND_CHARGES",
                ],
                'intl_Air': [
                    "ORIGIN_INLAND_CHARGES",
                    "ORIGIN_LOCAL_PORT_CHARGES",
                    "FREIGHT_CHARGES",
                    "DESTINATION_LOCAL_PORT_CHARGES",
                    "DESTINATION_INLAND_CHARGES",
                ]
            };

            // Get headers for the selected shipment type
            const headers = chargeHeaders[shipmentType] || chargeHeaders['FCL'];

            // Create tariff details structure
            const tariffDetails = headers.map(header => ({
                header,
                fclTariffBreakDowns: [],
                selected: true,
            }));

            // Update state with the new tariff details
            setTariffDetails(tariffDetails);

            // Dispatch actions to add each charge to the quote modal
            headers.forEach(header => {
                dispatch({
                    type: ADD_QUOTE_MODAL_CHARGES,
                    payload: {
                        id: 'quote_0',
                        charge_name: header
                    }
                });
            });

            return tariffDetails;
        } catch (error) {
            console.error('Error loading charges:', error);
            return [];
        }
    };

    // Create a function that can be called directly from tab click events
    const reloadCharges = useCallback(() => {
        if (!isApplyBids && !isAdditionalBooking) {
            //console.log("Manually reloading charges for", tabName);
            // First clear existing charges
            dispatch({ type: REMOVE_QUOTE_MODAL_CHARGES });
            // Then load charges for the current tab
            chargesLoad(tabName);
        }
    }, [tabName, isApplyBids, dispatch, isAdditionalBooking]);

    // This effect runs when the component mounts and when tabName changes
    useEffect(() => {
        //console.log(tabName, "Tab Name Changed");
        smartQuotationFormik.setFieldValue('tabName', tabName);
        // Only process for non-bid applications && non-booking-additional-sibmission
        if (!isApplyBids && !isAdditionalBooking) {
            dispatch({ type: REMOVE_QUOTE_MODAL_CHARGES });
            // Load charges for the current tab
            chargesLoad(tabName);
        }

        // Cleanup function when component unmounts
        return () => {
            dispatch({ type: REMOVE_QUOTE_MODAL_CHARGES });
        };
    }, [tabName, isApplyBids, dispatch, isAdditionalBooking]);

    // Expose the reloadCharges function to the parent component via ref
    useEffect(() => {
        if (reloadChargesRef && typeof reloadChargesRef === 'object') {
            reloadChargesRef.current = reloadCharges;
        }
    }, [reloadChargesRef, reloadCharges]);

    const handleChangeHandler = (item, name) => {
        dispatch({ type: UPDATE_SEARCH_INSTANT_RATE_DATA, payload: { item, name } });
    }

    const onBiddingReset = () => {
        if (isBidingBtnClick) {
            setIsBidingBtnClick(!isBidingBtnClick);
            dispatch({ type: QUOTE_MODAL_INITIAL });
            setTariffDetails([])
            const headers = [
                "ORIGIN_INLAND_CHARGES",
                "ORIGIN_LOCAL_PORT_CHARGES",
                "FREIGHT_CHARGES",
                "DESTINATION_LOCAL_PORT_CHARGES",
                "DESTINATION_INLAND_CHARGES",
            ];
            const tariffDetails = headers.map(header => ({
                header,
                fclTariffBreakDowns: [],
                selected: true,
            }));

            //console.log(tariffDetails, "tariffDetails SHIP");
            setTariffDetails(tariffDetails);
        }
    }

    const applyBidsFormik = useFormik({
        enableReinitialize: false,
        initialValues: {
            inquiriesId: inquiriesId,
            quote_currency: smartQuotationsValues?.quote_currency ? smartQuotationsValues?.quote_currency : { value: 'US DOLLAR', label: 'USD', currencyCode: 'USD', id: 3, version: 0 },
            carrierMaster: "",
            originDetentionFree: '',
            destinationDetentionFree: '',
            validFrom: formatServerDate(new Date()),
            validTo: "",
            transitTime: '',
            remarks: '',
        },
        validationSchema: ApplyBidsValidationSchema,
        validateOnChange: true,
        validateOnBlur: false,
        onSubmit: (values) => {
            let isfinalSubmit = true;
            console.log(mainChargeObj, "mainChargeObj");
            if (mainChargeObj.length > 0) {
                mainChargeObj[0].tariffDetails.map((obj) => {
                    obj.fclTariffBreakDowns.map((object) => {
                        let errorObject = applyBiddingChargesValidate(object);
                        isfinalSubmit = errorObject.isValid;
                        if (!errorObject.isValid) {
                            //console.log(`Please fill all required fields. in ${obj.header} Section `);
                            showErrorToast(`Please fill all required fields. in ${obj.header.trim().replace(/_/g, " ")} Section `);
                        }
                    });
                });
            } else {
                setIsBidingBtnClick(false);
                isfinalSubmit = false
                showWarnToast("Please add some charges");
            }

            if (isfinalSubmit) {
                submitFinalBiding(values);
            }
        }
    });

    useEffect(() => {
        setSmartQuotationsFormError({});
        if (Object.keys(applyBidsFormik.errors).length > 0) {
            //console.log('There are applyBidsFormik errors:', applyBidsFormik.errors);
            setSmartQuotationsFormError(applyBidsFormik.errors)
        }
    }, [applyBidsFormik.errors])

    const submitFinalBiding = (values) => {
        console.log(mainChargeObj, "mainChargeObj");
        //console.log(inquiriesDetailsData, "inquiriesDetailsData");
        //console.log(activeQuotationsViewDetails, "activeQuotationsViewDetails");
        console.log(quoteData, "quoteData");
        let sellerTenantObject = {
            sellerTenantId: tenant_info?.id
        }

        let historyData = quoteData.map(data => {
            return {
                statusTime: new Date().toTimeString().split(' ')[0],
                statusDate: new Date().toISOString().split('T')[0],
                reasonMasterId: reason_master?.find(reason => String(reason?.reasonCode) === "INVALID")?.id,
                statusMasterId: status_master?.find(status => String(status?.statusCode) === VERIFIED)?.id,
            };
        });

        const totalBidCost = mainChargeObj[0]?.tariffDetails?.reduce((tariffSum, tariff) => {
            const breakdownSum = (tariff.fclTariffBreakDowns || []).reduce(
                (sum, item) => sum + parseFloat(item.sales_cost || 0),
                0
            );
            return tariffSum + breakdownSum;
        }, 0) || 0;

        const inquiryField = activeQuotationsViewDetails?.inquiryField;

        let data = {
            tenantFclQuotationSellerTenants: [sellerTenantObject],
            ...(inquiryField?.customerId !== null && { tenantCustomerId: inquiryField?.customerId }),
            ...(inquiriesDetailsData?.customerName !== null && { contactName: inquiriesDetailsData?.customerName }),
            inquiryDetailId: inquiriesId,
            statusMasterId: status_master?.find(status => String(status?.statusCode) === BID_SUBMITTED)?.id,
            tenantFclQuotationStatusHistories: historyData,
            tenantFclQuotationCarrierDetails: mainChargeObj?.map((data, index) => {
                const originalCharges = data.tariffDetails.flatMap(charge =>
                    charge.fclTariffBreakDowns.map(breakDown => {
                        return {
                            currency: currency_data?.find(currency => String(currency.currencyCode) === String(breakDown?.currencyCode)),
                            chargeHeader: charge?.header,
                            unitOfMeasurement: UOM_data?.find(uom => String(uom?.value) === String(breakDown?.uomCode?.value)),
                            unitCost: breakDown?.unit,
                            chargeName: breakDown?.component?.label,
                            totalBuyCost: parseInt(breakDown?.unitPerPrice) || 0,
                            totalSaleCost: parseInt(breakDown?.sales_cost) || parseInt(breakDown?.amount) || parseInt(breakDown?.total_sale_cost),
                        };
                    })
                );

                return {
                    carrierMaster: vendor_carrier_data?.content?.find(item => item.id === values?.carrierMaster?.value) || values?.carrierMaster || {},
                    tenantVendorId: values?.carrierMaster?.tenantVendor?.id,
                    destinationLocationType: inquiryField?.destinationType,
                    originLocationType: inquiryField?.originType,

                    ...(inquiryField?.originType === 'ICD' && { originPortId: inquiryField?.originIcdId }),
                    ...(inquiryField?.originType === 'OCEAN_PORT' && { originPortId: inquiryField?.originPortId }),
                    ...(inquiryField?.originType === 'CITY' && { originPortId: inquiryField?.originPortId, orginCityId: inquiryField?.originCityId }),

                    ...(inquiryField?.destinationType === 'ICD' && { destinationPortId: inquiryField?.destinationIcdId }),
                    ...(inquiryField?.destinationType === 'OCEAN_PORT' && { destinationPortId: inquiryField?.destinationPortId }),
                    ...(inquiryField?.destinationType === 'CITY' && { destinationPortId: inquiryField?.destinationPortId, destinationCityId: inquiryField?.destinationCityId }),
                    remarks: values?.remarks || '',
                    tenantFclQuotationsCarrierCharges: originalCharges,
                    detentionFreeOrg: parseInt(values?.originDetentionFree),
                    detentionFreeDest: parseInt(values?.destinationDetentionFree),
                    quotationValidFrom: values?.validFrom,
                    quotationValidTo: values?.validTo,
                    transitTime: values?.transitTime,
                    quotationValue: totalBidCost,
                };
            })
        };
        setIsBidingBtnClick(true);
        console.log(data, "Apply Bidding data");
        dispatch(postTenantQuotationSummeryDetails(data));
        setTimeout(() => {
            navigate(-1);
        }, 500);
    }

    const smartQuotationFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            // Include tabName in form values for validation
            tabName: tabName,
            //Customer
            customerName: '',
            contactName: '',
            customerAddress: '',
            contactEmail: '',
            contactNumber1: '',
            contactNumber: '',
            //address
            location_from: '',
            location_to: '',
            originCityId: 0,
            destinationCityId: 0,
            //Shipment
            cargoType: { value: 'GENERAL', label: 'GENERAL', id: '1', version: '0' },
            commodity: '',
            cargoValue: '',
            incoterms: '',
            containers: [
                { containerType: '', quantity: '', weight: '' },
            ],
            //Additional
            originDetentionFree: '',
            destinationDetentionFree: '',
            validFrom: formatServerDate(new Date()),
            validTo: '',
            issueDate: new Date().toISOString().split("T")[0],
            transitTime: '',
            remarks: '',
            // Others Formik
            quote_currency: { label: 'INR', value: 'rupee', currencyCode: "INR", id: 2, version: 0 },
            viaPort: "",
            carrierMaster: "",
            exchangeRate: 83
        },
        validationSchema: !isApplyBids && !isAdditionalBooking ? ShippingQuotationValidationSchema : null,
        validateOnChange: isApplyBids && isAdditionalBooking ? false : true,
        validateOnBlur: isApplyBids && isAdditionalBooking ? false : false,
        onSubmit: (values) => {
            // const errors = await formikHelpers.validateForm(values);
            // if (Object.keys(errors).length > 0) {

            // } else {

            // }

            console.log(values, "Values");
            let isfinalSubmit = true;
            if (mainChargeObj.length > 0) {
                mainChargeObj[0].tariffDetails.map((obj) => {
                    obj.fclTariffBreakDowns.map((object) => {
                        let errorObject = smartQuotationMainChargesValidate(object);
                        isfinalSubmit = errorObject.isValid;
                        if (!errorObject.isValid) {
                            //console.log(`Please fill all required fields. in ${obj.header} Section `);
                            showErrorToast(`Please fill all required fields. in ${obj.header.trim().replace(/_/g, " ")} Section `);
                        }
                    });
                });
            } else {
                previewQuotationHandler(values);
            }

            if (isfinalSubmit) {
                previewQuotationHandler(values);
            }
        },
    });

    useEffect(() => {
        setSmartQuotationsFormError({});
        if (Object.keys(smartQuotationFormik.errors).length > 0) {
            //console.log('There are smartQuotationFormik errors:', smartQuotationFormik.errors);
            setSmartQuotationsFormError(smartQuotationFormik.errors)
        }
    }, [smartQuotationFormik.errors]);

    useEffect(() => {
        const value = smartQuotationFormik?.values?.incoterms?.value;
        if (value !== undefined && value !== null) {
            //console.log(value);
            // const tariffMap = {
            //     1: [
            //         "ORIGIN_INLAND_CHARGES",
            //         "ORIGIN_LOCAL_PORT_CHARGES",
            //         "FREIGHT_CHARGES",
            //         "DESTINATION_LOCAL_PORT_CHARGES",
            //         "DESTINATION_INLAND_CHARGES",
            //     ],
            //     10: [
            //         "ORIGIN_LOCAL_PORT_CHARGES",
            //         "FREIGHT_CHARGES",
            //         "DESTINATION_LOCAL_PORT_CHARGES",
            //         "DESTINATION_INLAND_CHARGES",
            //     ],
            //     12: [
            //         "ORIGIN_LOCAL_PORT_CHARGES",
            //         "FREIGHT_CHARGES",
            //         "DESTINATION_LOCAL_PORT_CHARGES",
            //         "DESTINATION_INLAND_CHARGES",
            //     ],
            //     13: [
            //         "FREIGHT_CHARGES",
            //         "DESTINATION_LOCAL_PORT_CHARGES",
            //         "DESTINATION_INLAND_CHARGES",
            //     ],
            //     2: [
            //         "DESTINATION_LOCAL_PORT_CHARGES",
            //         "DESTINATION_INLAND_CHARGES",
            //     ],
            //     3: [
            //         "DESTINATION_LOCAL_PORT_CHARGES",
            //         "DESTINATION_INLAND_CHARGES",
            //     ],
            //     5: [
            //         "DESTINATION_LOCAL_PORT_CHARGES",
            //         "DESTINATION_INLAND_CHARGES",
            //     ],
            // };
        }

    }, []);
    //smartQuotationFormik?.values.incoterms

    const onContainerTypeChange = (value, index, name) => {
        //console.log(value, index, name)
        let id = 'quote_0';
        let charge_name = 'FREIGHT_CHARGES';
        dispatch({ type: UPDATE_QUOTE_MODAL_CHARGES, payload: { charge_name, id, value, name, index, sales_cost: 0, newVal: 0 } })
        dispatch({
            type: UPDATE_QUOTE_MODAL_CHARGES, payload: {
                charge_name, id, value: { label: 'PER CONTAINER', value: 'PER_CONTAINER', description: 'PER CONTAINER', id: 2, version: 0 },
                name: 'uomCode', index, sales_cost: 0, newVal: 0
            }
        });
        dispatch({ type: UPDATE_QUOTE_MODAL_CHARGES, payload: { charge_name, id, value: true, name: 'isDefault', index, sales_cost: 0, newVal: 0 } });
        dispatch({ type: UPDATE_QUOTE_MODAL_CHARGES, payload: { charge_name, id, value: 2, name: 'inPosition', index, sales_cost: 0, newVal: 0 } });
    }

    const chargesIndex = (chargeHeader) => {
        switch (chargeHeader) {
            case 'ORIGIN_INLAND_CHARGES':
                return 0;
            case "ORIGIN_LOCAL_PORT_CHARGES":
                return 1;
            case 'FREIGHT_CHARGES':
                return 2;
            case 'DESTINATION_LOCAL_PORT_CHARGES':
                return 3;
            case 'DESTINATION_INLAND_CHARGES':
                return 4;
        }
    }

    const previewQuotationHandler = (values) => {
        mainChargeObj[0].tariffDetails.forEach(tariff => {
            tariff.fclTariffBreakDowns = tariff.fclTariffBreakDowns.filter(breakDown => {
                const {
                    component,
                    currencyCode,
                    markup_type,
                    markup_val,
                    total_sale_cost,
                    unitPerPrice,
                    uomCode
                } = breakDown;

                const isEmpty =
                    component === "" &&
                    currencyCode === "" &&
                    markup_type === "" &&
                    markup_val === "" &&
                    total_sale_cost === "" &&
                    unitPerPrice === "" &&
                    uomCode === "";

                return !isEmpty; // keep only non-empty ones
            });
        });
        const transformedTariffDetails = mainChargeObj[0]?.tariffDetails.map((item, index) => {
            const cleanedBreakdowns = (item.fclTariffBreakDowns || []).filter(breakDown => {
                return breakDown && ['component', 'currencyCode', 'markup_type', 'markup_val', 'unitPerPrice', 'uomCode']
                    .some(key => breakDown?.[key]);
            });
            const breakdowns = cleanedBreakdowns.map(breakDown => {
                const totalSaleCost = Number(breakDown.total_sale_cost) || 0;
                //const amount = convertCurrency(breakDown, totalSaleCost, currency_ExchangeRate, smartQuotationsValues);
                return {
                    amount: totalSaleCost,
                    component: breakDown.component?.label || '',
                    componentDescription: breakDown.component?.description || '',
                    containerDetail: item.containerType || '',
                    currencyCode: breakDown.currencyCode || '',
                    destinationId: values?.location_to?.value || null,
                    destinationName: values?.location_to?.label || '',
                    margin_value: Number(breakDown.margin_value) || 0,
                    markup_val: Number(breakDown.markup_val) || 0,
                    originId: values?.location_from?.value || null,
                    originName: values?.location_from?.label || '',
                    taxDetail: {
                        taxPercentage: 0,
                        value: 0
                    },
                    total_sale_cost: totalSaleCost,
                    transitTime: item.transitTime || 0,
                    unit: Number(breakDown.unit) || 0,
                    unitPerPrice: Number(breakDown.unitPerPrice) || 0,
                    uomCode: breakDown.uomCode?.value || '',
                    uomDescription: breakDown.uomCode?.description || ''
                };
            });

            return {
                chargeId: item.chargeId || 0,
                fclTariffBreakDowns: breakdowns,
                from: values?.location_from?.label || '',
                to: values?.location_to?.label || '',
                header: item.header || '',
                order: chargesIndex(item.header), // or item.order if you have that in your data
                selected: true,
                portName: item.portName || undefined // optional, only if available
            };
        });

        let payload = {
            chargeId: 0,
            carrierId: values?.carrierMaster?.value,
            carrierName: values?.carrierMaster?.carrierCode,
            customerId: values?.customerName?.value,
            customerName: values?.customerName?.label,
            contactName: values?.contactName,
            customerAddress: values?.customerAddress,
            contactEmail: values?.contactEmail,
            contactNumber: values?.contactNumber,
            quote_id: 'quote_0',

            originCityId: values?.originCityId,
            destinationCityId: values?.destinationCityId,

            originId: values?.location_from?.value || 0,
            originName: values?.location_from?.label || '',
            destinationId: values?.location_to?.value || 0,
            destinationName: values?.location_to?.label || '',

            validFrom: values?.validFrom || '',
            validTo: values?.validTo || '',
            oceanTransitTime: 0,
            detentionFreeOrg: values?.originDetentionFree || 0,
            detentionFreeDest: values?.destinationDetentionFree || 0,
            originLocationType: values?.location_from?.locationType || '',
            destinationLocationType: values?.location_to?.locationType || '',
            issueData: values?.issueDate || new Date(),
            alternateRoute: false,
            quoteCurrency: values?.quote_currency,
            totalAllCharges: 0,
            totalCost: totalsByCurrency?.grandTotal || 0,
            subTotalCost: totalsByCurrency?.subTotal || 0,
            totalCostList: totalsByCurrency?.total || [],
            tenantName: tenant_info?.name,
            tenantId: tenant_info?.id,
            carrierInfo: values?.carrierMaster,
            quoteFrom: 'smartQuotation',
            tariffDetails: transformedTariffDetails
        }
        //console.log(payload, "previewQuotationHandler");
        let payloadArray = [];
        payloadArray.push(payload);
        dispatch({ type: QUOTATION_RESULT_SELECTED, payload: payloadArray });
        setPreviewModal(true);
        QuoteModalHandler();
    }


    const additionalChargesBooking = useFormik({
        enableReinitialize: true,
        initialValues: {
            originDetentionFree: quoteData[0]?.detentionFreeOrg || '0',
            destinationDetentionFree: quoteData[0]?.detentionFreeDest || '0',
            validFrom: quoteData[0]?.validFrom || formatServerDate(new Date()),
            validTo: quoteData[0]?.validTo || '',
            issueDate: new Date().toISOString().split("T")[0],
            transitTime: quoteData[0]?.oceanTransitTime || '0',
            remarks: '',
        },
        onSubmit: (values) => {
            console.log(values, "values");
            handleAdditionalChargeSubmit(values);
        }
    });

    const handleAdditionalChargeSubmit = (values) => {
        console.log(quoteData, "quoteData");
        console.log(values, "values");

        // const allFclTariffBreakDowns = quoteData?.flatMap(item =>
        //     item.tariffDetails?.flatMap(tariff => tariff.fclTariffBreakDowns || [])
        // ) || [];

        //console.log(allFclTariffBreakDowns, "allFclTariffBreakDowns");

        if (mainChargeObj[0]) {
            mainChargeObj[0].tariffDetails = getMainChargeObjRemoveEmpty(mainChargeObj);
        }

        let margin = 0;
        let remark = "";
        let data = quoteData.map((data, index) => {
            remark = data?.remarks;
            margin = overAllMarginHandler(mainChargeObj, data, currency_ExchangeRate, smartQuotationsValues, subTotalHandler(mainChargeObj, data, currency_ExchangeRate, smartQuotationsValues));
            const originalCharges = getOriginalQuoteData(data, quoteData, container_data, UOM_data, currency_data);
            return {
                tenantFclQuotationsCarrierCharges: originalCharges,
                carrierId: data?.carrierId
            };
        });

        quoteTenantdata?.tenantFclQuotationCarrierDetails.forEach(carrierDetails => {
            carrierDetails.tenantFclQuotationsCarrierCharges = data?.[0]?.tenantFclQuotationsCarrierCharges;
            carrierDetails.grossMargin = margin;
            carrierDetails.remarks = values?.remarks || remark;
            //carrierDetails.tenantFclQuotationsCarrierCharges = data?.find(obj => obj?.carrierId === carrierDetails?.tenantCarrier?.id)?.tenantFclQuotationsCarrierCharges;
            const processOthersChargeResult = processOthersCharge(mainChargeObj, quoteData, currency_data, container_data, UOM_data);
            processOthersChargeResult.map((item, index) => {
                carrierDetails.tenantFclQuotationsCarrierCharges?.push(item);
            });
        });

        let historyData = {
            statusMasterId: status_master?.find((item) => item?.statusCode === CUST_APPRVD_PENDING)?.id,
            tenantFclQuotationSummary: { id: quoteTenantdata?.id, version: quoteTenantdata?.version }
        }
        quoteTenantdata.tenantFclQuotationStatusHistories.push(historyData);
        quoteTenantdata.statusMasterId = status_master?.find((item) => item?.statusCode === CUST_APPRVD_PENDING)?.id;
        quoteTenantdata.bookingSummeryId = inquiriesDetailsData?.bookingSummeryId;
        //console.log(quoteTenantdata, "quoteTenantdata");
        dispatch(postTenantQuotationSummeryDetails(quoteTenantdata));
        setTimeout(() => {
            navigate(-1);
        }, 500);
    }

    useEffect(() => {
        const mergedTotals = mergeTotalsByCurrency(mainObjTotal, quoteTotal);
        setTotalsByCurrency([mergedTotals]);
    }, [mainObjTotal, quoteTotal]);

    return (
        <>
            <div className="quotation_modal_wrap">
                <Accordion flush open={open} toggle={toggle} className='main_accordion'>
                    <>
                        {!isApplyBids && !isAdditionalBooking && (
                            <>
                                <AccordionItem id="customerInfoStep" className={hasErrorKeys(smartQuotationsFormError, ['customerName']) ? 'error' : ''}>
                                    <AccordionHeader targetId="customerdetails">
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                            <span>Customer Details</span>
                                            <div className="d-flex align-items-center gap-4 ms-2">
                                                <span className="w-50">Issue Date</span>
                                                <div onClick={(e) => e.stopPropagation()}>
                                                    <Input
                                                        type="date"
                                                        name="issueDate"
                                                        value={smartQuotationFormik?.values?.issueDate}
                                                        min={new Date().toISOString().split("T")[0]} // disables past dates
                                                        onChange={smartQuotationFormik.handleChange}
                                                        onBlur={smartQuotationFormik.handleBlur}
                                                        className="form-control"
                                                        placeholder="Set Today"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionHeader>
                                    <AccordionBody accordionId={`customerdetails`}>
                                        {/*<CompanyForm />*/}
                                        <CustomerDetails customerDetailsFormik={smartQuotationFormik} />
                                    </AccordionBody>
                                </AccordionItem>
                                {/* <AccordionItem id="addressInfoStep" className={hasErrorKeys(smartQuotationsFormError, ['location_from', 'location_to']) ? 'error' : ''}>
                                    <AccordionHeader targetId={`addressdetails`}>
                                        Address Details
                                    </AccordionHeader>
                                    <AccordionBody accordionId={`addressdetails`}>
                                        <AddressDetails addressDetailsFormik={smartQuotationFormik} />
                                    </AccordionBody>
                                </AccordionItem> */}
                            </>
                        )}
                        <AccordionItem id="shippingInfoStep"
                            className={isApplyBids && isAdditionalBooking ? '' : hasErrorKeys(smartQuotationsFormError, ['cargoType', 'carrierMaster', 'incoterms']) ? 'error' : ''}>
                            <AccordionHeader targetId={`shipmentdetails`}>
                                Shipping Details
                            </AccordionHeader>
                            <AccordionBody accordionId={`shipmentdetails`}>
                                <ShipmentDetails tabName={tabName} shipmentDetailsFormik={smartQuotationFormik} onContainerTypeChange={onContainerTypeChange} isApplyingBid={isApplyBids} isAdditionalCharge={isAdditionalBooking} />
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem id="chargesInfoStep" className={isApplyBids && isAdditionalBooking ? '' : hasErrorKeys(smartQuotationsFormError, ['carrierMaster']) ? 'error' : ''}>
                            <AccordionHeader targetId={`chargesdetails`}>
                                <div className="d-flex justify-content-between align-items-center w-100">
                                    {/* Left Side: Label + Carrier Select */}
                                    <div className="d-flex align-items-center gap-4">
                                        <span className="mb-0">Carrier & Charges</span>
                                        <div style={{ minWidth: '400px' }} onClick={(e) => e.stopPropagation()}>
                                            <div className="charges_wrap">
                                                <div className="field_wrap">
                                                    {isAdditionalBooking ? (
                                                        <>
                                                            <div className="highlight-box">
                                                                <span className="highlight-text">
                                                                    {vendor_carrier_data?.content
                                                                        ?.filter(item => item.transportMode === 'OCEAN')?.find(item => item.id === quoteData[0]?.carrierId)?.name}
                                                                    &nbsp;({vendor_carrier_data?.content
                                                                        ?.filter(item => item.transportMode === 'OCEAN')?.find(item => item.id === quoteData[0]?.carrierId)?.carrierCode})
                                                                </span>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Select
                                                                name="carrierMaster"
                                                                options={vendor_carrier_data?.content
                                                                    ?.filter(item => item.transportMode === 'OCEAN')
                                                                    ?.map(({ id, name, carrierCode, version, tenantVendor }) => ({
                                                                        value: id,
                                                                        label: `${name} (${carrierCode})`,
                                                                        name,
                                                                        carrierCode,
                                                                        version,
                                                                        tenantVendor,
                                                                    }))
                                                                }
                                                                value={isApplyBids ? applyBidsFormik.values.carrierMaster : smartQuotationFormik.values.carrierMaster}
                                                                placeholder='Select Carrier....'
                                                                onChange={(selectedOption) => {
                                                                    //console.log(selectedOption, "Carrier master");
                                                                    if (isApplyBids) {
                                                                        onBiddingReset();
                                                                        applyBidsFormik.setFieldValue('carrierMaster', selectedOption);
                                                                        applyBidsFormik.setFieldTouched('carrierMaster', true);
                                                                    } else {
                                                                        smartQuotationFormik.setFieldValue('carrierMaster', selectedOption);
                                                                        dispatch({
                                                                            type: SMART_QUOTATION_VALUE_UPDATE,
                                                                            payload: { carrierMaster: selectedOption },
                                                                        });
                                                                    }
                                                                }}
                                                                classNamePrefix="form-select"
                                                                styles={{
                                                                    control: (baseStyles, state) => ({
                                                                        ...baseStyles,
                                                                        borderColor: (smartQuotationFormik.errors.carrierMaster || applyBidsFormik.errors.carrierMaster) ? 'red' : 'grey',
                                                                    }),
                                                                }}
                                                            />
                                                        </>)
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    {/* Right Side: Currency + Margin + Filter */}
                                    <div className="d-flex align-items-center gap-3" onClick={(e) => e.stopPropagation()}>
                                        <Select
                                            name="quote_currency"
                                            options={currency_data?.map(({ value, currencyCode, id, version }) => ({
                                                value,
                                                label: currencyCode,
                                                currencyCode,
                                                id,
                                                version,
                                            }))}
                                            value={isApplyBids || isAdditionalBooking ? applyBidsFormik.values.quote_currency : smartQuotationFormik.values.quote_currency}
                                            onChange={(selectedOption) => {
                                                if (isApplyBids || isAdditionalBooking) {
                                                    applyBidsFormik.setFieldValue('quote_currency', selectedOption);
                                                } else {
                                                    smartQuotationFormik.setFieldValue('quote_currency', selectedOption);
                                                    handleChangeHandler(selectedOption, "quote_currency");
                                                }
                                                dispatch({
                                                    type: SMART_QUOTATION_VALUE_UPDATE,
                                                    payload: { quote_currency: selectedOption },
                                                });
                                            }}
                                            classNamePrefix="react-select"
                                            styles={{ container: base => ({ ...base, minWidth: '80px' }) }}
                                        />
                                        <div onClick={(e) => { e.stopPropagation(); toggleRightCanvas(); }} style={{ cursor: "pointer" }}>
                                            <img src={filter_icon} alt="filter" />
                                        </div>
                                    </div>
                                </div>
                            </AccordionHeader>
                            <AccordionBody accordionId={`chargesdetails`}>
                                {isAdditionalBooking ?
                                    <PreQuotationsCharges tabName={tabName} tariffDetails={tariffDetails} isApplyingBids={isApplyBids} isSubmitAdditonalChages={isAdditionalBooking} validation={chargesValidation} locationFrom={locationFrom} /> :
                                    <Charges tabName={tabName} tariffDetails={tariffDetails} isApplyingBids={isApplyBids} validation={chargesValidation} locationFrom={locationFrom} />}
                            </AccordionBody>
                        </AccordionItem>
                        <AccordionItem id="additionalInfoStep" className={hasErrorKeys(smartQuotationsFormError, ['destinationDetentionFree', 'originDetentionFree', 'validTo']) ? 'error' : ''}>
                            <AccordionHeader targetId={`additionaldetails`}>
                                Additional Details
                            </AccordionHeader>
                            <AccordionBody accordionId={`additionaldetails`}>
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Origin Detention free in days<span
                                                className='required_star'>*</span></label>
                                            <div className="charges_wrap">
                                                <div className="field_wrap">
                                                    <Input
                                                        type="number"
                                                        minLength={1}
                                                        maxLength={100}
                                                        name="originDetentionFree"
                                                        className={smartQuotationFormik?.errors?.originDetentionFree || applyBidsFormik?.errors?.originDetentionFree ? 'error' : ''}
                                                        value={isAdditionalBooking ? additionalChargesBooking?.values?.originDetentionFree || '' : (isApplyBids ? applyBidsFormik?.values?.originDetentionFree : smartQuotationFormik?.values?.originDetentionFree)}
                                                        onChange={isApplyBids ? applyBidsFormik.handleChange : smartQuotationFormik.handleChange}
                                                        onBlur={isApplyBids ? applyBidsFormik.handleBlur : smartQuotationFormik.handleBlur}
                                                        placeholder="Origin Detention free"
                                                        readOnly={isAdditionalBooking ? true : false}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Destination Detention free in days<span
                                                className='required_star'>*</span></label>
                                            <div className="charges_wrap">
                                                <div className="field_wrap">
                                                    <Input
                                                        type="number"
                                                        minLength={1}
                                                        maxLength={100}
                                                        name="destinationDetentionFree"
                                                        value={isAdditionalBooking ? additionalChargesBooking?.values?.destinationDetentionFree : (isApplyBids ? applyBidsFormik?.values?.destinationDetentionFree : smartQuotationFormik?.values?.destinationDetentionFree)}
                                                        onChange={isApplyBids ? applyBidsFormik.handleChange : smartQuotationFormik.handleChange}
                                                        onBlur={isApplyBids ? applyBidsFormik.handleBlur : smartQuotationFormik.handleBlur}
                                                        className={smartQuotationFormik?.errors?.destinationDetentionFree || applyBidsFormik?.errors?.destinationDetentionFree ? 'error' : ''}
                                                        placeholder="Destination Detention free"
                                                        readOnly={isAdditionalBooking ? true : false}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label className="form-label">Valid From<span
                                                className='required_star'>*</span></label>
                                            <Input
                                                type="date"
                                                name="validFrom"
                                                min={new Date().toISOString().split("T")[0]} // disables past dates
                                                value={isAdditionalBooking ? additionalChargesBooking?.values?.validFrom || '' : (isApplyBids ? applyBidsFormik?.values?.validFrom || '' : smartQuotationFormik?.values?.validFrom || '')}
                                                onChange={isApplyBids ? applyBidsFormik.handleChange : smartQuotationFormik.handleChange}
                                                onBlur={isApplyBids ? applyBidsFormik.handleBlur : smartQuotationFormik.handleBlur}
                                                placeholder="Origin Detention free"
                                                readOnly={isAdditionalBooking ? true : false}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label className="form-label">Valid To<span
                                                className='required_star'>*</span></label>
                                            <Flatpickr
                                                name="validTo"
                                                value={isAdditionalBooking
                                                    ? additionalChargesBooking?.values?.validTo
                                                    : (
                                                        isApplyBids
                                                            ? applyBidsFormik?.values?.validTo
                                                            : smartQuotationFormik?.values?.validTo || ''
                                                    )}
                                                className={smartQuotationFormik?.errors?.validTo || applyBidsFormik?.errors?.validTo ? 'form-control d-block error' : 'form-control d-block'}
                                                placeholder="Select Date"
                                                options={{
                                                    altFormat: "F j, Y",
                                                    dateFormat: "Y-m-d",
                                                    minDate: "today"
                                                }}
                                                onChange={(selectDate) => {
                                                    const formatted = selectDate.map(d => {
                                                        const year = d.getFullYear();
                                                        const month = String(d.getMonth() + 1).padStart(2, '0');
                                                        const day = String(d.getDate()).padStart(2, '0');
                                                        return `${year}-${month}-${day}`;
                                                    });

                                                    if (isApplyBids) {
                                                        applyBidsFormik.setFieldValue("validTo", formatted[0])
                                                    } else {
                                                        smartQuotationFormik.setFieldValue("validTo", formatted[0]);
                                                    }
                                                }}
                                                readOnly={isAdditionalBooking ? true : false}
                                                disabled={isAdditionalBooking ? true : false}
                                                tabIndex={0}
                                            />
                                            {/*<Input*/}
                                            {/*    type="date"*/}
                                            {/*    name="validTo"*/}
                                            {/*    className={smartQuotationFormik?.errors?.validTo || applyBidsFormik?.errors?.validTo ? 'form-control error' : 'form-control'}*/}
                                            {/*    min={new Date().toISOString().split("T")[0]} // disables past dates*/}
                                            {/*    value={isApplyBids ? applyBidsFormik?.values?.validTo : smartQuotationFormik?.values?.validTo || ''}*/}
                                            {/*    onChange={isApplyBids ? applyBidsFormik.handleChange : smartQuotationFormik.handleChange}*/}
                                            {/*    onBlur={isApplyBids ? applyBidsFormik.handleBlur : smartQuotationFormik.handleBlur}*/}
                                            {/*    placeholder="Valid To"*/}
                                            {/*/>*/}
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label className="form-label">Transit Time in days<span
                                                className='required_star'>*</span></label>
                                            <Input
                                                type="number"
                                                minLength={1}
                                                maxLength={100}
                                                name="transitTime"
                                                className={smartQuotationFormik?.errors?.transitTime || applyBidsFormik?.errors?.transitTime ? 'form-control d-block error' : 'form-control d-block'}
                                                value={isAdditionalBooking ? additionalChargesBooking?.values?.transitTime || '' : (isApplyBids ? applyBidsFormik?.values?.transitTime || '' : smartQuotationFormik?.values?.transitTime || '')}
                                                onChange={isApplyBids ? applyBidsFormik.handleChange : smartQuotationFormik.handleChange}
                                                onBlur={isApplyBids ? applyBidsFormik.handleBlur : smartQuotationFormik.handleBlur}
                                                placeholder="Transit Time"
                                                readOnly={isAdditionalBooking ? true : false}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label className="form-label">Remarks</label>
                                    <Input
                                        type="textarea"
                                        name="remarks"
                                        value={smartQuotationFormik?.values?.remarks || applyBidsFormik?.values?.remarks || additionalChargesBooking?.values?.remarks || ''}
                                        onChange={isAdditionalBooking ? additionalChargesBooking?.handleChange : isApplyBids ? applyBidsFormik.handleChange : smartQuotationFormik.handleChange}
                                        onBlur={isAdditionalBooking ? additionalChargesBooking?.handleBlur : isApplyBids ? applyBidsFormik.handleBlur : smartQuotationFormik.handleBlur}
                                        className={smartQuotationFormik?.errors?.remarks || applyBidsFormik?.errors?.remarks || additionalChargesBooking?.errors?.remarks ? 'form-control error' : 'form-control'}
                                        rows="5"
                                        placeholder="Enter Remarks"
                                    />

                                </div>
                            </AccordionBody>
                        </AccordionItem>
                    </>
                </Accordion>
            </div>
            <div className="mt-4" style={{ maxWidth: '1345px' }}>
                <Row className="align-items-start">
                    <Col md="6">
                        {!isApplyBids && (
                            <Table bordered responsive className="text-center">
                                <thead className="bg-light">
                                    <tr>
                                        <th>TOTAL</th>
                                        <th>ORIGIN</th>
                                        <th>DESTINATION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {totalsByCurrency?.[0]?.total?.map((item, index) => (
                                        <tr key={index}>
                                            <td><strong>Total <span className="text-uppercase">{item?.currencyCode || '-'}</span>:</strong></td>
                                            <td><strong>{item?.originTotal?.toFixed(2) || '0.00'}</strong></td>
                                            <td><strong>{item?.destinationTotal?.toFixed(2) || '0.00'}</strong></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        )}
                    </Col>
                    <Col md="6" className="text-end">
                        <div className="text-end">
                            {/* {!isApplyBids ? (
                                <>
                                    <div className="btn_wrap">
                                        <button type="button" className='btn border_btn' onClick={smartQuotationFormik.handleReset}>Cancel</button>
                                        <button
                                            id="previewSubmiBtnArea"
                                            type="button"
                                            className="btn btn-primary ms-2"
                                            onClick={smartQuotationFormik.handleSubmit}>
                                            Preview Quotation
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="btn_wrap">
                                        <button type="button" className='btn border_btn' onClick={applyBidsFormik.handleReset}>Cancel</button>
                                        <button
                                            type="button"
                                            className="btn btn-primary ms-2"
                                            disabled={isBidingBtnClick}
                                            onClick={applyBidsFormik.handleSubmit}>
                                            Submit
                                        </button>
                                    </div>
                                </>
                            )} */}
                            {isAdditionalBooking ? (
                                <div className="btn_wrap">
                                    <button type="button" className="btn border_btn" onClick={additionalChargesBooking.handleReset}>Cancel</button>
                                    <button
                                        type="button"
                                        className="btn btn-primary ms-2"
                                        onClick={async () => {
                                            const errors = await additionalChargesBooking.validateForm();
                                            if (Object.keys(errors).length === 0) {
                                                setConfirmationModal(true);
                                            } else {
                                                additionalChargesBooking.setTouched(
                                                    Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {})
                                                );
                                            }
                                        }}>
                                        Save Charges
                                    </button>
                                </div>
                            ) : isApplyBids ? (
                                <div className="btn_wrap">
                                    <button type="button" className="btn border_btn" onClick={applyBidsFormik.handleReset}>Cancel</button>
                                    <button
                                        type="button"
                                        className="btn btn-primary ms-2"
                                        disabled={isBidingBtnClick}
                                        onClick={applyBidsFormik.handleSubmit}>
                                        Submit
                                    </button>
                                </div>
                            ) : (
                                <div className="btn_wrap">
                                    <button type="button" className="btn border_btn" onClick={smartQuotationFormik.handleReset}>Cancel</button>
                                    <button
                                        id="previewSubmiBtnArea"
                                        type="button"
                                        className="btn btn-primary ms-2"
                                        onClick={smartQuotationFormik.handleSubmit}>
                                        Preview Quotation
                                    </button>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
            {confirmationModal && <ConfirmationModal isOpen={confirmationModal} setOpen={setConfirmationModal} buttonText={bookingRequestButtonText} message={bookingRequestMessage} shortMessage={bookingRequestShortMesssage} title={bookingRequestTitle} confirm={additionalChargesBooking.handleSubmit} />}
        </>
    );
}

export default ShippingQuotationForm;
